export enum EBannerType {
  MortgageBroker,
  SubsidisedMortgage,
  CianDobro,
  RentKpnCallback,
  RentNBListing,
  DailyRent,
}
